import React, { useEffect } from "react"
import { useState } from "react"
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap'
import CaregiverSearch from "./CaregiverSearch"
import { connect, useSelector } from "react-redux";
import { TabActionCaregiver } from "../../actions/CaregiverActions";
import CaregiverTab from './CaregiverTab'
import { useDispatch } from "react-redux";
import { Modal } from "react-bootstrap";
import ModalHeader from "../Setup/Shared/ModalHeader";
import TextEditor from "../../shared-components/TextEditor";
import DatePicker from "../General/DatePicker";
import handleCopyText from "../shared/CopyData";

const Caregiver = (props) => {
    let data = useSelector(state => state.Open_Caregiver_Tab)

    let dispatch = useDispatch();
    const [tabList, setTabsList] = useState([{
        active: true,
        key: 2,
        name: "Caregiver",
        data: {
            name: "All Caregiver",
            id: 0,
        },
    },])
    const [activeTab, setActiveTab] = useState(0)
    const [recordsNum, setRecordsNum] = useState(false)

    useEffect(() => {
        if (props.OpenDynamicTab && props.OpenDynamicTab.length > 0) {
            AddDynamicTabData(props)
        }
        else {
            setTabsList([{
                active: true,
                key: 2,
                name: "Caregiver",
                data: {
                    name: "All Caregiver",
                    id: 0,
                },
            },])
            setActiveTab(0)
        }

    }, [props.OpenDynamicTab])

    const AddDynamicTabData = (data) => {
        let tabDataFromRedux = data.OpenDynamicTab.length > 0 ? data.OpenDynamicTab : [];
        const DataFromRedux = tabDataFromRedux.filter((ele) => { return ele.key === 2; });   // fetch only whose id is 2
        const activeElements = DataFromRedux.filter((row) => row.active === true); // get active 
        if (activeElements.length > 0 && tabList.length === 1) {
            let tabsData = [...tabList]
            tabsData = tabsData.concat(...DataFromRedux)
            setTabsList(tabsData)
            setActiveTab(activeElements[0].data.id)
        } else {
            let firstCaregiverTab = tabList.filter((el) => el.data.id === 0);
            let tabs = [...firstCaregiverTab]
            // check if all pat exist in redux 
            const isExist = tabDataFromRedux.some((ele) => { return ele.key === 2 && ele.data.id === 0; });
            if (isExist) {
                setTabsList(DataFromRedux)
            } else {
                tabs = tabs.concat(...DataFromRedux)
                setTabsList(tabs)
            }
            setActiveTab(activeElements[0].data.id)
        }
    }
    // active tab 
    const handleActiveTab = (item) => {
        console.log(item);
        const { data } = { ...item }
        if (activeTab !== data?.id) {
            setActiveTab(data?.id)
        }

        if (item.data.id !== 0) {
            let obj = {
                key: 2,
                name: "Caregiver",
                active: true,
                data: {
                    id: data?.id,
                    name: data?.name,
                    time: new Date()
                },
            };
            props.TabActionCaregiver(obj);
        }

    }
    // handle to close tab
    const handleCloseTab = async (id) => {
        let index = tabList.findIndex((el) => el.data.id === id);
        tabList.splice(index, 1);
        let activTab =
            tabList.length > 0
                ? tabList[tabList.length - 1].data.id
                : 0;
        setTabsList(tabList)
        setActiveTab(activTab)
        props.TabActionCaregiver({}, id);
    };
    return (
        <>
            <div className='app-tabs fix-tabs'>
                <Nav className="rb-tabs bg-light-blue nav-tabs pt-1 hk-cross-tabs ar_tabs-changes">
                    {tabList && tabList.map((item) => {
                        return (
                            <React.Fragment key={item.data.id}>
                                <NavItem >
                                    <NavLink
                                        href="#"
                                        className={activeTab === item.data.id ? "active" : ""}
                                        onClick={() => {
                                            handleActiveTab(item);
                                            handleCopyText(`${item.data.name}`);
                                        }}
                                    >   {console.log(">><<", item.data.name)}
                                        {item.data.name}

                                    </NavLink>
                                    {item.data.id === 0 ? null :
                                        <span onClick={() => handleCloseTab(item.data.id)} class="icon-cross-cricle fs-15"><span class="path1"></span><span class="path2"></span></span>
                                    }
                                    {item.data.id === 0 ? <div className="counter heading">{recordsNum}</div> : null}
                                </NavItem>
                            </React.Fragment>
                        )
                    })}
                </Nav>
                <TabContent activeTab={activeTab}>
                    {tabList &&
                        tabList.filter((el) => el.data.id === 0).map((item) => {
                            return (
                                <React.Fragment key={item.data.id}>
                                    <TabPane tabId={item.data.id}>
                                        <CaregiverSearch setRecordsNum={setRecordsNum} />
                                    </TabPane>
                                </React.Fragment>
                            )
                        })}
                    {tabList &&
                        tabList.filter((el) => el.data.id !== 0).map((item) => {
                            return (
                                <React.Fragment key={item.data.id}>
                                    <TabPane tabId={item.data.id}>
                                        <CaregiverTab Active={activeTab} />
                                    </TabPane>
                                </React.Fragment>
                            )
                        })}
                </TabContent>
            </div>

            {/* Alert Message Modal */}
            <Modal show={false} onHide={false} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-lg hk-modal-v1 master_list_modal hk-alert__modal ar_palceholder">
                <Modal.Body>
                    <ModalHeader HeaderName={() => { }} DeletePopup={""} isClosed={() => { }} key={631} Name={'SwitchPractice'} />
                    <div className='br-clr mt-3'>
                        <div className="row">
                            <div className="col-12">
                                <div className="opened-block">
                                    <p className="heading text-center">Alert Message</p>

                                    <div className="opened-block__lite">
                                        <TextEditor value={"Hi John.............."} />

                                        <div className="row opened-block__lite__form">
                                            <div className="col-5 mt-2">
                                                <DatePicker
                                                    label='Start Date'
                                                    value={""}
                                                    handleCalendarChangefunc={() => { }}
                                                />
                                            </div>
                                            <div className="col-5 mt-2">
                                                <DatePicker
                                                    label='End Date'
                                                    value={""}
                                                    handleCalendarChangefunc={() => { }}
                                                />
                                            </div>
                                            <div className="col-6 mt-2">
                                                <div className="form-check custom_check_box   d-flex align-items-center gap-1">
                                                    <input type="checkbox" className="form-check-input" id="global" />
                                                    <label className="form-check-label" for="global">Global</label>
                                                </div>
                                                <div className="form-check custom_check_box   d-flex align-items-center gap-1">
                                                    <input type="checkbox" className="form-check-input" id="appointement" />
                                                    <label className="form-check-label" for="appointement">Show Alert in Appointment Section</label>
                                                </div>
                                                <div className="form-check custom_check_box   d-flex align-items-center gap-1">
                                                    <input type="checkbox" className="form-check-input" id="patient" />
                                                    <label className="form-check-label" for="patient">Show Alert in Caregiver Section</label>
                                                </div>
                                            </div>
                                            <div className="col-6 mt-2">
                                                <div className="form-check custom_check_box   d-flex align-items-center gap-1">
                                                </div>
                                                <div className="form-check custom_check_box   d-flex align-items-center gap-1">
                                                    <input type="checkbox" className="form-check-input" id="appointement" />
                                                    <label className="form-check-label" for="appointement">Show Alert in Claim Section</label>
                                                </div>
                                                <div className="form-check custom_check_box   d-flex align-items-center gap-1">
                                                    <input type="checkbox" className="form-check-input" id="patient" />
                                                    <label className="form-check-label" for="patient">Show Alert in Payment Section</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 master_footer d-flex gap-3 mt-2 justify-content-end">
                                    <button className="btn btn-orange btn-xs no-width rounded mb-0 master_list_add">Save</button>
                                    <button className="btn btn-orange btn-xs no-width rounded mb-0 master_list_close">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {/* Alerts Small Modal */}
            <Modal show={false} onHide={false} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-lg hk-modal-v1 master_list_modal hk-alert__modal hk-alerts_box hk-alerts_leftBox ar_palceholder">
                <Modal.Body>
                    <div className='br-clr mt-3'>
                        <div className="row">
                            <div className="col-12">
                                <div className="opened-block">
                                    <p className="heading text-center">
                                        <i className="icon-alert" />
                                        Alerts for Caregiver ROBERT, ALEX
                                    </p>

                                    <div className="opened-block__lite">
                                        <div className="opened-block__lite__boxes">
                                            <p>Member’s coverage with UHC termed on 10/31/2023 2 UHC</p>
                                            <p>Member’s coverage with UHC termed on 10/31/2023 2 UHC</p>
                                        </div>
                                        <div className="opened-block__lite__boxes">
                                            <p>By: Jameji on 03/04/2023</p>
                                            <p>Caregiver: ROBERT, ALEX</p>
                                        </div>
                                    </div>
                                    <div className="opened-block__lite">
                                        <div className="opened-block__lite__boxes">
                                            <p>Member’s coverage with UHC termed on 10/31/2023 2 UHC</p>
                                            <p>Member’s coverage with UHC termed on 10/31/2023 2 UHC</p>
                                        </div>
                                        <div className="opened-block__lite__boxes">
                                            <p>By: Jameji on 03/04/2023</p>
                                            <p>Caregiver: ROBERT, ALEX</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 master_footer d-flex gap-3 mt-2 justify-content-end">
                            <button className="btn btn-orange btn-xs no-width rounded mb-0">Close</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={false} onHide={false} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-lg hk-modal-v1 master_list_modal hk-alert__modal hk-alerts_box ar_palceholder">
                <Modal.Body>
                    <div className='br-clr mt-3'>
                        <div className="row">
                            <div className="col-12">
                                <div className="opened-block">
                                    <p className="heading text-center">
                                        <i className="icon-alert" />
                                        Alerts for Caregiver ROBERT, ALEX
                                    </p>

                                    <div className="opened-block__lite">
                                        <div className="opened-block__lite__boxes">
                                            <p>Member’s coverage with UHC termed on 10/31/2023 2 UHC</p>
                                            <p>Member’s coverage with UHC termed on 10/31/2023 2 UHC</p>
                                        </div>
                                        <div className="opened-block__lite__boxes">
                                            <p>By: Jameji on 03/04/2023</p>
                                            <p>Caregiver: ROBERT, ALEX</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 master_footer d-flex gap-3 mt-2 justify-content-end">
                            <button className="btn btn-orange btn-xs no-width rounded mb-0">Close</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={false} onHide={false} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-lg master_list_modal hk-alert__modal hk-alerts_box hk-modal-v1 hk-alerts_rightBox ar_palceholder">
                <Modal.Body>
                    <div className='br-clr mt-3'>
                        <div className="row">
                            <div className="col-12">
                                <div className="opened-block">
                                    <p className="heading text-center">
                                        <i className="icon-alert" />
                                        Alerts for Caregiver ROBERT, ALEX
                                    </p>

                                    <div className="opened-block__lite">
                                        <div className="opened-block__lite__boxes">
                                            <p>Member’s coverage with UHC termed on 10/31/2023 2 UHC</p>
                                            <p>Member’s coverage with UHC termed on 10/31/2023 2 UHC</p>
                                        </div>
                                        <div className="opened-block__lite__boxes">
                                            <p>By: Jameji on 03/04/2023</p>
                                            <p>Caregiver: ROBERT, ALEX</p>
                                        </div>
                                    </div>
                                    <div className="opened-block__lite">
                                        <div className="opened-block__lite__boxes">
                                            <p>Member’s coverage with UHC termed on 10/31/2023 2 UHC</p>
                                            <p>Member’s coverage with UHC termed on 10/31/2023 2 UHC</p>
                                        </div>
                                        <div className="opened-block__lite__boxes">
                                            <p>By: Jameji on 03/04/2023</p>
                                            <p>Caregiver: ROBERT, ALEX</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 master_footer d-flex gap-3 mt-2 justify-content-end">
                            <button className="btn btn-orange btn-xs no-width rounded mb-0">Close</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

function mapStateToProps(state) {
    return {
        OpenDynamicTab: state.Open_Caregiver_Tab ? state.Open_Caregiver_Tab : [],
    };
}

const action = {
    TabActionCaregiver,
};


export default connect(mapStateToProps, action)(Caregiver)

